<template>
  <div class="row mt-1 mb-1">
    <div class="col">
      <div class="card m-1" style="background: #30455F">
        <div class="card-body m-0 p-2 d-flex align-items-center" style=" color: #FFFFFF">
          <div style="font-size: 1.4em; text-transform: uppercase;">
            {{ title }}
          </div>
          <div class="ml-2" style="font-weight: 300">
            {{ description }}
          </div>
          <div class="ml-auto" style="font-size: 10px; cursor: pointer;" v-if="showVisibility !== undefined" @click="toggleVisibility">{{ isVisible ? 'HIDE' : 'SHOW' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: [
    'title',
    'description',
    'showVisibility'
  ],
  data: function () {
    return {
      isVisible: false
    }
  },
  methods: {
    toggleVisibility () {
      this.isVisible = !this.isVisible
      this.$emit('visibilitySwitch', this.isVisible)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/homePage/TitleBar2.vue